<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <menu-layout>
      <router-view/>
    </menu-layout>
  </div>
</template>

<script>
import logo from './assets/logo.png'
export default {
  name: 'App',
  data () {
    return {logo}
  },
  created () {
    this.$store.dispatch('getColumnTreeList')
    this.$store.dispatch('getFooterList')
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    // 后期可以做成动态图标
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = this.logo
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}
</script>

<style>
#app {
  /*font-family: SourceHanSansCN-Regular-GBpc-EUC-H-, SourceHanSansCN-Regular-GBpc-EUC-H;*/
  font-family: 微软雅黑, Tahoma, Helvetica, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(360deg, rgba(255,255,255,0) 0%, rgba(182,220,255,0.14) 19%, rgba(103,183,255,0.3) 43%, rgba(46,157,255,0.41) 66%, rgba(12,140,255,0.47) 85%, rgba(0,135,255,0.5) 99%);
  /*width: 1680px;*/
  min-height: 190px;
  min-width: 1255px;
}
/*::-webkit-scrollbar{*/
/* display: none;*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/App.vue